import { createSelector } from 'reselect';

import { TState } from '~/src/store';

export const selectIsOfferTransactionPayed = createSelector(
    [
        (state: TState) => ({
            transactions: state.payment.transactions,
            offerTransaction: state.specOffers.transaction,
        }),
    ],
    ({ transactions, offerTransaction }) => transactions.some(({ id, payed }) => id === offerTransaction && payed),
);
